import events from ".";
import api from "/api";
import notify from "/utils/notify";

events.on("abtest:ready", () => {
  api.plans()
    .then(data => events.emit("plans:ready", data))
    .catch(error => {
      notify("Failed to fetch plans");
      events.emit("plans:error", error);
    });
});
